<template>
	<div>
		<v-dialog v-model="isVisibleInternal" max-width="1000px" @input="$emit('update:isVisible', isVisibleInternal)">
			<v-card>
				<v-card-title class="headline primary white--text ">
					{{title}}
				</v-card-title>
				<v-card-text>
					{{hint}}
				</v-card-text>
				<v-card-text style="width: 50%;">
					<v-autocomplete
						v-model="model"
						:items="items"
						:loading="isLoading"
						color="grey"
						hide-no-data
						hide-selected
						item-text="Description"
						item-value="API"
						:label="searchFieldLabel"
						:placeholder="searchFieldPlaceholder"
						prepend-icon="mdi-database-search"
						aria-label="autocomplete field"
						return-object
                        multiple
					>
                    <template v-slot:selection="">
     
    </template>
                </v-autocomplete>
				</v-card-text>
				<v-divider></v-divider>
				<!-- <v-expand-transition v-if="model"> -->
					<v-list v-for="(oneModel, j) in model"
							:key="j" class="grey lighten-2">
						<v-list-tile
							v-for="(headerValue, i) in Object.keys(headers)"
							:key="i"
						>
							<v-list-tile-content>
								<v-list-tile-title v-text="oneModel[headerValue] || '-'"></v-list-tile-title>
								<v-list-tile-sub-title v-text="oneModel[headerValue]"></v-list-tile-sub-title>
                                
							</v-list-tile-content>
                            <v-icon @click="deleteItem(j)">delete</v-icon>

						</v-list-tile>
					</v-list>
				<!-- </v-expand-transition> -->
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						:disabled="!model"
						color="primary"
						@click="$emit('save',model); model = null;"
					>
						Zapisz
					</v-btn>
					<v-btn
						:disabled="!model"
						color="primary"
						@click="model = null;"
					>
						Resetuj
					</v-btn>


					<v-btn
						color="blue"
						@click="$emit('cancel'); model = null;"
					>
						Anuluj
					</v-btn>

				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>

	export default {
		name: "egrantyAutocompleteMulti",
		data() {
			return {
				dialog: false,
				user: [],
				model: null,
				isLoading: false,
				isVisibleInternal: false,
			};
		},

		computed: {
			items() {
				let ids = this.model ? this.model.map(x=>x.id) : [];
				return this.possibilities
				.filter(x=>{
					return (ids.length > 0) ? !ids.includes(x.id) : true;
				}).map(entry => {
					const Description = this.description(entry);

					return Object.assign({}, entry, {Description});
				});
			},
		},
        methods: {
            deleteItem(index){
                this.model.splice(index,1);
            }
        },

		watch: {
			isVisible: {
				immediate: true,
				handler(val) {
					this.isVisibleInternal = val;
				},
			},
		},

		props: {
			title: {
				type: String,
				default: "",
			},

			hint: {
				type: String,
				default: "",
			},

			searchFieldLabel: {
				type: String,
				default: "",
			},

			searchFieldPlaceholder: {
				type: String,
				default: "",
			},

			filters: {
				type: Object,
				default: function () {
					return {};
				},
			},

			possibilities: Array,
			headers: Object,
			isVisible: Boolean,
			description: {
				type: Function,
				default: (entry) => entry.name + " " + (entry.surname !== undefined ? entry.surname : ""),
			},
		},
	};
</script>

<style scoped>

	.theme--dark .v-list {
		background-color: #1b1B1B !important;
	}

	.theme--light .v-btn.v-btn--disabled .v-btn__content {
		color: #fff;
	}
</style>
